<template>
  <paginate
    v-model="page"
    :page-count="pageCount"
    :prev-text='"<i class=\"icon--back\"></i>"'
    :next-text='"<i class=\"icon--next\"></i>"'
    :click-handler="clickHandler"
    container-class="pagination"
    page-class="pagination__item"
    prev-link-class="pagination__nav--prev"
    next-link-class="pagination__nav--next"
    active-class="pagination__item--active">
  </paginate>
</template>

<script>
export default {
  name: 'DqPaginate',
  props: {
    value: [String, Number],
    pageCount: Number,
    clickHandler: Function
  },
  computed: {
    page: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  }
}
</script>
